import { Field, TextInput } from '@carboledger/ui';
import { useTranslations } from '@/hooks';

/**
 * Props:
 *   disabled  locks the control while only other fields may change
 */
export const TransportNameField = ({ disabled = false }) => {
  const t = useTranslations();

  return (
    <Field name="transportName">
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <TextInput
          id={id}
          name={name}
          label={t('FORM_TRANSPORT_NAME')}
          placeholder={t('FORM_TRANSPORT_NAME_PLACEHOLDER')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          disabled={disabled}
        />
      )}
    </Field>
  );
};

/**
 * Props:
 *   fieldName  the form value it writes — declarations store it as `vessel`
 *   disabled   locks the control while only other fields may change
 */
export const VesselNameField = ({ fieldName = 'vesselName', disabled = false }) => {
  const t = useTranslations();

  return (
    <Field name={fieldName}>
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <TextInput
          id={id}
          name={name}
          label={t('FORM_VESSEL_NAME')}
          placeholder={t('FORM_VESSEL_NAME_PLACEHOLDER')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          disabled={disabled}
        />
      )}
    </Field>
  );
};
